import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./AdminImage.module.css";
import { Download } from "@mui/icons-material";
import { ImageUrlPrefix } from "../../../../../../labels";
import Loader from "../../../../Loader";
import { customStyles } from "../../../../../../pages/customStyles";
import toast from "react-hot-toast";
import Creatable from "react-select/creatable";
import { AxiosInstance } from "../../../../../../axios";
import dayjs from "dayjs";

export default function AddImageAdminInfo() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  const location = useLocation();
  const {
    FOLDER_NAME,
    FOLDER_PK,
    DISPLAY_OPTION,
    ORIGINAL_GALLERY_PATH,
    GALLERY_PATH,
    DESCRIPTION,
  } = location.state || {};
  const imageRef = useRef(null);
  const folder_ref = useRef(null);
  const navigate = useNavigate();
  const [imageFilesUploadedList, setImageFilesUploadedList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileName, setFilesName] = useState([]);
  const [invalidFiles, setInvalidFiles] = useState([]);
  const [existFolderData, setExistFolderData] = useState([]);
  const [fileError, setFileError] = useState("");
  const [selectedImage, setSelectedImage] = useState([]);
  const [visibleImage, setVisibleImage] = useState(false);
  const [initialfields, setInitialfields] = useState({
    id: "",
    folder_pk: "",
    folder_name: "",
    description: "",
    title: "",
    img_type: 1,
    display_option: 1,
    gallery_path: "",
    original_gallery_path: "",
    created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: userid || "",
    is_deleted: 0,
    files: [],
  });

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFilesName(files);
    setFileError("");
    setInvalidFiles([]); // Clear previous invalid files
    const maxFileCount = 10;
    const maxFileSize = 2 * 1024 * 1024; // 2MB

    if (files.length > maxFileCount) {
      setFileError(`You can only upload up to ${maxFileCount} files.`);
      setSelectedFiles([]);
      return;
    }

    const oversizedFiles = files.filter((file) => file.size > maxFileSize);
    const nonImageFiles = files.filter(
      (file) => !file.type.startsWith("image/")
    );

    if (nonImageFiles.length > 0) {
      setFileError("Only image files are allowed.");
      setSelectedFiles([]);
      return;
    }

    if (oversizedFiles.length > 0) {
      setInvalidFiles(oversizedFiles);
      setFileError(
        `The following image(s) exceed 2MB and were not uploaded: ${oversizedFiles
          .map((file) => file.name)
          .join(", ")}`
      );
      setSelectedFiles([]);
      return;
    }

    // All files are valid
    const validFiles = files.map((file) => ({
      file,
      description: "",
    }));
    setSelectedFiles(validFiles);
  };

  useEffect(() => {
    setInitialfields({
      folder_name: FOLDER_NAME,
      folder_pk: FOLDER_PK,
      display_option: DISPLAY_OPTION,
      gallery_path: GALLERY_PATH,
      original_gallery_path: ORIGINAL_GALLERY_PATH,
    });
    setSelectedFiles((prevFiles) => {
      if (prevFiles.length === 0 && id) {
        return [{ description: DESCRIPTION }]; // Add default object
      }
      return prevFiles.map((file) => ({
        ...file,
        description: DESCRIPTION || "",
      }));
    });
  }, [FOLDER_NAME, FOLDER_PK, DISPLAY_OPTION, GALLERY_PATH, DESCRIPTION]);

  useEffect(() => {
    handleMapNewFolderNames();
  }, []);
  useEffect(() => {
    if (imageFilesUploadedList.length > 0 && selectedImage) {
      setImageFilesUploadedList((prev) =>
        prev.map((file, i) => ({
          ...file,
          path: selectedImage.gallery_path || file.path,
          originalname:
            selectedImage.original_gallery_path || file.originalname,
        }))
      );
    }
  }, [selectedImage]);
  // /List api
  const handleMapNewFolderNames = async () => {
    setIsLoading(true);
    return AxiosInstance.post("/api/gallery/folderList", folderPayloadImage)
      .then((res) => {
        const uniqueSubcategories = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.folder_name,
        }));
        setExistFolderData(uniqueSubcategories);
        if (id) {
          let imageData = res?.data?.data?.filter(
            (item) => item.id === parseInt(id)
          );
          setVisibleImage(
            imageData[0]?.display_option === 1
              ? "yes"
              : imageData[0]?.display_option === 0
              ? "no"
              : null
          );
          // setInitialfields((prev) => ({
          //   ...prev,
          //   folder_pk: imageData[0]?.id,
          //   folder_name: imageData[0]?.folder_name,
          //   original_gallery_path: imageData[0]?.original_gallery_path,
          // }));
          setSelectedImage(imageData[0]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (event) => {
    const { name, files, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };
  const folderPayloadImage = {
    type: 1,
  };

  // Folder name handler
  const handleFolderNameChange = (selectedOptions, dname) => {
    // const isNew = selectedOptions.__isNew__;
    if (dname === "folder_pk") {
      setInitialfields((prevState) => ({
        ...prevState,
        ["folder_pk"]: selectedOptions?.value,
        ["folder_name"]: selectedOptions?.label,
        // ...(isNew && { name: "", id: "" }),
      }));
      setError({
        ...error,
        [dname]: "",
      });
    }
  };

  const handleDownloadImages = async () => {
    if (imageFilesUploadedList.length > 0) {
      for (let i = 0; i < imageFilesUploadedList.length; i++) {
        const image = imageFilesUploadedList[i];
        const imagePath = `${ImageUrlPrefix}/${image.path}`; // Construct the image URL path
        try {
          const response = await fetch(imagePath);
          if (!response.ok) {
            throw new Error(`Failed to fetch image: ${imagePath}`);
          }
          const imageBlob = await response.blob();
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(imageBlob); // Convert the Blob to a downloadable URL
          downloadLink.download = image.path.split("/").pop(); // Extract file name from the path
          downloadLink.click(); // Trigger the download
          URL.revokeObjectURL(downloadLink.href);
        } catch (error) {
          console.error(`Error fetching image from path ${imagePath}:`, error);
        }
      }
    } else {
      console.log("No images to download.");
    }
  };

  // const validateFocusCommentSection = (COMSECFO) => {
  //   if (!COMSECFO.folder_name) {
  //     folder_ref.current.focus();
  //   } else if (!COMSECFO.gallery_path) {
  //     imageRef.current.focus();
  //   } else if (selectedFiles.length === 0) {
  //     setFileError("Please select at least one image");
  //   }
  // };
  const validateFields = (data, files) => {
    const errors = {};
    const imageDescriptionErrors = [];

    if (!data.folder_pk) {
      errors.folder_pk = "Please select folder name";
    }
    if (files.length <= 0) {
      setFileError("Please select at least one image");
    }
    if (invalidFiles.length > 0) {
      setFileError(
        `The following image(s) exceed 2MB and were not uploaded: ${invalidFiles
          .map((file) => file.name)
          .join(", ")}`
      );
      errors.invalidFiles = true;
    }
    files?.forEach((image, index) => {
      if (
        image?.is_valid !== 0 &&
        image.description &&
        image.description.trim().length > 200
      ) {
        imageDescriptionErrors[index] =
          "Description not exceed 200 characters";
      }
    });

    if (imageDescriptionErrors.length > 0) {
      errors.imageDescriptions = imageDescriptionErrors;
    }

    return errors;
  };

  const handleSave = () => {
    const err_bnh = validateFields(initialfields, selectedFiles);
    const maxFileCount = 10;
    const maxFileSize = 2 * 1024 * 1024; // 2MB
    if (fileName.length > maxFileCount) {
      setFileError(`You can only upload up to ${maxFileCount} files.`);
      setSelectedFiles([]);
      return;
    }
    if (Object.keys(err_bnh).length === 0) {
      setFileError("");
      try {
        if (id) {
          const uploadedFiles = [
            {
              path: GALLERY_PATH,
              originalname: ORIGINAL_GALLERY_PATH,
              description: selectedFiles[0]?.description || "",
            },
          ];
          // If an id is provided, update the data
          const updateCoures = {
            id: id,
            display_option: initialfields.display_option,
            files: uploadedFiles,
            folder_name: initialfields.folder_name,
            folder_pk: initialfields.folder_pk,
            title: "",
            img_type: 1,
            created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid || "",
            is_deleted: 0,
          };
          AxiosInstance.post(`/api/gallery/add`, updateCoures)
            .then((res) => {
              if (res.status) {
                toast.success(res.data.message);
                navigate(-1);
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          if (fileName?.length > 0) {
            const formData = new FormData();
            fileName.forEach((file) => {
              formData.append("gallery_image", file);
            });
            setIsLoading(true);
            AxiosInstance.post("api/upload/", formData)
              .then((response) => {
                setIsLoading(false);
                const uploadedFiles = response?.data?.path.map(
                  (item, index) => ({
                    path: item.path,
                    originalname: item.originalname,
                    description: selectedFiles[index]?.description || "",
                  })
                );
                setImageFilesUploadedList(uploadedFiles);

                if (id) {
                  // If an id is provided, update the data
                  const updateCoures = {
                    id: id,
                    display_option: initialfields.display_option,
                    files: uploadedFiles,
                    folder_name: initialfields.folder_name,
                    folder_pk: initialfields.folder_pk,
                    title: "",
                    img_type: 1,
                    created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                    created_by: userid || "",
                    is_deleted: 0,
                  };
                  AxiosInstance.post(`/api/gallery/add`, updateCoures)
                    .then((res) => {
                      if (res.status) {
                        toast.success(res.data.message);
                        navigate("/GalleryImages");
                      } else {
                        toast.error(res.data.message);
                      }
                    })
                    .catch((error) => {
                      return error;
                    });
                } else {
                  const createCouresInfoData = {
                    id: "",
                    display_option: 1,
                    files: uploadedFiles,
                    folder_name: initialfields.folder_name,
                    folder_pk: initialfields.folder_pk,
                    title: initialfields.title,
                    img_type: 1,
                    created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                    created_by: userid || "",
                  };
                  AxiosInstance.post(`/api/gallery/add`, createCouresInfoData)
                    .then((res) => {
                      if (res.status) {
                        toast.success(res.data.message);
                        navigate("/GalleryImages");
                      } else {
                        toast.error(res.data.message);
                      }
                    })
                    .catch((error) => {
                      return error;
                    });
                }
              })
              .catch((error) => {
                console.error("Error uploading files:", error);
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };

  const handleDescriptionChange = (index, value) => {
    // Update descriptions
    setSelectedFiles((prev) =>
      prev.map((image, i) =>
        i === index
          ? {
              ...image,
              path: image.path || selectedImage?.gallery_path || "",
              originalname:
                image.originalname ||
                selectedImage?.original_gallery_path ||
                "",
              description: value,
            }
          : image
      )
    );

    // Handle error state for description
    setError((prev) => {
      const updatedErrors = { ...prev };
      if (!updatedErrors.imageDescriptions) {
        updatedErrors.imageDescriptions = [];
      }

      if (value.length > 200) {
        updatedErrors.imageDescriptions[index] =
          "Description not exceed 200 characters.";
      } else {
        updatedErrors.imageDescriptions[index] = "";
      }

      return updatedErrors;
    });
  };

  const handleDelete = (indexToDelete) => {
    setImageFilesUploadedList((prevState) =>
      prevState.map((imageObj, index) =>
        index === indexToDelete ? { ...imageObj, is_valid: 0 } : imageObj
      )
    );
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">{id ? "Edit Image" : "Add New Image"}</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/GalleryImages"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton"
                variant="secondary"
              >
                {id ? "Back to View Images" : "Back to Images"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSave}
                className="primaryButton text-center"
                variant="primary"
              >
                Save Image
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Image Details</legend>
            <form className="row g-3">
              {/* Upload  */}
              <div className="col-lg-6 col-md-12">
                <div className="forms">
                  <div className="d-flex">
                    <div className="row">
                      <label
                        htmlFor="formFile"
                        class={
                          id
                            ? "form-label confirm_value disabled_btn"
                            : "form-label confirm_value "
                        }
                      >
                        Upload Images (Max 10 Image, Max 2MB each)
                      </label>
                    </div>
                    {/* {id
                      ? null
                      : imageFilesUploadedList.length > 0 && (
                        <div
                          className={
                            id
                              ? ` ${styles.disabled}`
                              : "d-flex align-content-center p-0"
                          }
                        >
                          {initialfields.gallery_path !== "" &&
                            initialfields.gallery_path !== null && (
                              <>
                                <a onClick={handleDownloadImages}>
                                  <Download className="download_icon" />
                                </a>
                              </>
                            )}
                        </div>
                      )} */}
                  </div>
                  <div className="row">
                    <div className={id ? `col-md-3 col-5` : `col-md-12`}>
                      <input
                        type="file"
                        className={`InputsSelectFile ${
                          id ? "nn_upload_width" : "vv_upload_width"
                        }`}
                        disabled={id ? true : false}
                        placeholder="Enter question path"
                        required
                        id="gallery_path"
                        name="gallery_path"
                        multiple
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFileChange}
                      />
                    </div>
                    {id && (
                      <div
                        className={
                          "col-md-9 col-7 d-flex  align-content-center p-0"
                        }
                      >
                        <span className={styles.nn_upload_fileevaluator}>
                          {initialfields.gallery_path !== "" &&
                          initialfields.gallery_path !== null
                            ? initialfields.original_gallery_path
                            : ""}
                        </span>
                        <>
                          <span
                            className={`${styles.verified_uploadeval} material-icons align-middle text-danger`}
                          >
                            verified
                          </span>
                        </>
                      </div>
                    )}
                  </div>
                  {fileError && (
                    <small className="error_message">{fileError}</small>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <label
                  htmlFor="CourseGrouping"
                  className="form-label confirm_value pb-2"
                >
                  Folder Name
                </label>

                <Creatable
                  // ref={author_ref}
                  className={`shadow-none input-font-size `}
                  name="folder_pk"
                  value={
                    initialfields.folder_name && initialfields.folder_pk
                      ? {
                          value: initialfields.folder_pk,
                          label: initialfields.folder_name,
                        }
                      : null
                  }
                  onChange={(option) =>
                    handleFolderNameChange(option, "folder_pk")
                  }
                  options={existFolderData
                    ?.filter((item) => item && item.label) // Filter out null and undefined elements
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true}
                  isClearable={true}
                  isValidNewOption={() => false}
                  placeholder="Select folder name "
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                  // formatCreateLabel={(inputValue) => `Add New : ${inputValue}`}
                />

                {error.folder_pk && (
                  <small className="error_message">{error.folder_pk}</small>
                )}
              </div>
              <div>
                {id ? (
                  <label htmlFor="CourseGrouping" className=" confirm_value ">
                    Description
                  </label>
                ) : (
                  <></>
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "0px",
                }}
              >
                {selectedFiles?.length > 0 &&
                  selectedFiles.map(
                    (image, index) =>
                      image?.is_valid !== 0 && (
                        <div
                          className={`${styles.imageContainer}`}
                          style={
                            id
                              ? { borderBottom: "none", marginBottom: "0px" }
                              : {}
                          }
                          key={index}
                        >
                          {!id && (
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                              }}
                            >
                              <img
                                className="multiImage"
                                src={URL.createObjectURL(image.file)}
                                alt={`Preview ${index + 1}`}
                                style={{
                                  width: "150px",
                                  maxWidth: "100%",
                                  height: "auto",
                                  objectFit: "contain",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                  display: "block",
                                }}
                              />
                              <button
                                onClick={() => handleDelete(index)}
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  background: "red",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                &times;
                              </button>
                            </div>
                          )}

                          <div style={{ flex: 1 }}>
                            <textarea
                              className="desc_input_text w-100 rounded-2 input-font-size-sm"
                              placeholder="Enter description here (maximum 200 characters allowed)"
                              id="description"
                              onChange={(e) =>
                                handleDescriptionChange(index, e.target.value)
                              }
                              value={image.description || ""}
                              name="description"
                              style={{ resize: "none" }}
                            ></textarea>
                            {error?.imageDescriptions?.[index] && (
                              <small className="error_message">
                                {error.imageDescriptions[index]}
                              </small>
                            )}
                          </div>
                        </div>
                      )
                  )}
              </div>
              {/* --------Folder Name */}
              {/* {selectedFiles?.map((image, index) =>
                id ? (
                  <div className="col-md-6" key={index}>
                    <textarea
                      className="desc_input_text w-100 rounded-2 input-font-size-sm"
                      placeholder="Enter description here (maximum 200 characters allowed)"
                      id="description"
                      onChange={(e) => handleDescriptionChange(index, e.target.value)}
                      value={image?.description || ""}
                      name="description"
                      maxLength={200}
                      rows="4"
                    ></textarea>
                  </div>
                ) : null
              )} */}

              {/*======== Visible */}
              {id ? (
                <div className="col-md-6">
                  <label
                    htmlFor="Visible to Users"
                    className="form-label confirm_value"
                  >
                    Visible to Users
                  </label>

                  <div>
                    <input
                      // ref={optional_paper_ref}
                      className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                      type="radio"
                      id="yes"
                      name="display_option"
                      value={1}
                      checked={initialfields.display_option == 1}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="yes"
                      className={`${styles.margin_right} form-label confirm_value`}
                    >
                      Yes
                    </label>

                    <input
                      // ref={optional_paper_ref}
                      className={`shadow-none input-font-size ${styles.checkbox_radio}`}
                      type="radio"
                      id="no"
                      name="display_option"
                      // value={0}
                      value={0}
                      //  checked={initialfields.is_optional == 0 ? true : false}
                      //  onChange={handleChange}
                      checked={initialfields.display_option == 0}
                      onChange={handleChange}
                    />
                    <label htmlFor="no" className="form-label confirm_value">
                      No
                    </label>
                  </div>
                  {/* {error.is_optional && (
                 <small className={styles.errors}>
                   {error.is_optional}
                 </small>
               )} */}
                </div>
              ) : (
                <></>
              )}
            </form>
          </fieldset>
        </div>
        <div className="offset-md-12 col-12 ListBtn pt-2">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/GalleryImages"}
                onClick={id ? navigateToPreviousScreen : () => {}}
                className="secondaryButton"
                variant="secondary"
              >
                {id ? "Back to View Images" : "Back to Images"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSave}
                className="primaryButton text-center"
                variant="primary"
              >
                Save Image
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
